import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinpune() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Pune  ',
    heading: 'Sai Trupti Cabs: Corporate Cab Services in Pune  ',
    headingDescription: 'Sai Trupti Cabs offers professional and reliable Corporate Cab Services in Pune, designed to make employee transportation and business travel smooth, punctual, and stress-free for IT companies and corporate offices. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample space for comfortable daily travel and airport transfers. Every ride is handled by a trained, background-verified chauffeur ensuring timely pickups, safe driving, and courteous service for employees and executives. We provide flexible solutions like office pickup and drop services, airport corporate transfers, and long-term corporate cab contracts at transparent and competitive pricing. With GPS-enabled tracking, 24x7 online booking, and dedicated customer support, Sai Trupti Cabs ensures your corporate travel in Pune is efficient, reliable, and completely hassle-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



   "services": [
    {
      "name": "Corporate Taxi Service Pune",
      "description": "Professional corporate taxi service in Pune providing AC/non-AC Sedans, SUVs, Innova, and luxury cars for daily office commutes, airport transfers, and business trips. Features experienced drivers, real-time tracking, flexible schedules, and safe, timely rides for employees and executives."
    },
    {
      "name": "Corporate Cab Service Pune",
      "description": "Reliable corporate cab service in Pune offering one-way, round-trip, and shift-wise cab services with multiple vehicle options. Ideal for IT companies, BPOs, offices, and corporate clients requiring punctual, safe, and comfortable employee transport."
    },
    {
      "name": "Corporate Travel Cab Pune",
      "description": "Convenient corporate travel cab from Pune for business meetings, client visits, airport transfers, and long-distance corporate trips. Includes professional drivers, luggage support, AC/non-AC comfort, and real-time tracking."
    },
    {
      "name": "Corporate Car Rental Pune",
      "description": "Corporate car rental services in Pune providing chauffeur-driven and self-drive options. Multiple vehicles including Innova, Crysta, Sedan, SUV, and luxury cars available for daily commutes, office pickups, business trips, and outstation travel."
    },
    {
      "name": "Company Cab Service in Pune",
      "description": "End-to-end company cab service in Pune for employee transportation, office pickups, drop-offs, and shift-wise scheduling. Ensures safety, punctuality, professional drivers, AC/non-AC options, and flexible routes."
    },
    {
      "name": "Office Cab Service Pune",
      "description": "Dedicated office cab service in Pune for daily employee transport, airport transfers, and corporate events. Offers Sedans, SUVs, Innova, and luxury cars with experienced drivers, luggage assistance, and real-time tracking for reliable commutes."
    },
    {
      "name": "Corporate Cab Booking Pune",
      "description": "Online corporate cab booking platform in Pune with AC/non-AC options, professional drivers, flexible pickup/drop points, real-time tracking, and transparent fare structures for daily or occasional employee travel needs."
    },
    {
      "name": "Corporate Taxi Booking Pune",
      "description": "Seamless online taxi booking for corporate clients in Pune, offering multiple vehicle types, AC/non-AC options, punctual drivers, luggage support, and secure payment options for office, airport, or business travel."
    },
    {
      "name": "Best Corporate Cab Services in Pune",
      "description": "Top-rated corporate cab services in Pune providing safe, reliable, and comfortable transport solutions for employees and executives. Features include AC/non-AC vehicles, Innova, Crysta, SUV, Sedan, luxury cars, professional drivers, and shift-wise scheduling."
    },
    {
      "name": "Reliable Corporate Cab Service Pune",
      "description": "Trusted corporate cab service in Pune offering timely pickups, well-maintained vehicles, professional drivers, AC/non-AC comfort, luggage assistance, and real-time tracking for employee and executive transportation."
    },
    {
      "name": "Affordable Corporate Cab Services Pune",
      "description": "Budget-friendly corporate cab options in Pune for daily commutes, airport transfers, and employee transport. Includes AC/non-AC Sedans, SUVs, Innova, and reliable drivers ensuring safe and economical travel."
    },
    {
      "name": "Corporate Cab Service Provider Pune",
      "description": "Leading corporate cab service provider in Pune delivering AC/non-AC vehicles, professional chauffeurs, luggage assistance, flexible schedules, and shift-wise services tailored for offices, IT companies, and BPOs."
    },
    {
      "name": "Corporate Cab Vendor Pune",
      "description": "Professional corporate cab vendor in Pune offering employee transport solutions, office pickups/drop-offs, shift-based schedules, luxury and standard vehicles, experienced drivers, and real-time tracking for safe and timely rides."
    },
    {
      "name": "Employee Transport Service Pune",
      "description": "Dedicated employee transport service in Pune providing daily office commutes, shift-wise pickups, airport transfers, and corporate travel. Offers AC/non-AC vehicles, professional drivers, and secure, punctual transport for staff."
    },
    {
      "name": "Office Pickup Drop Cab Pune",
      "description": "Reliable office pickup and drop cab service in Pune with multiple vehicle types, AC/non-AC options, professional drivers, luggage assistance, and flexible schedules for daily employee transportation."
    },
    {
      "name": "Staff Transportation Service Pune",
      "description": "Safe and timely staff transportation service in Pune providing daily office commutes, airport transfers, and corporate travel. Features AC/non-AC Sedans, SUVs, Innova, and luxury vehicles with experienced drivers."
    },
    {
      "name": "Employee Cab Service Pune",
      "description": "Employee-focused cab service in Pune with shift-wise schedules, AC/non-AC vehicles, professional drivers, luggage support, real-time tracking, and punctual office pickups and drop-offs."
    },
    {
      "name": "Daily Office Cab Service Pune",
      "description": "Daily corporate cab service in Pune offering AC/non-AC Sedans, SUVs, and Innova for office commutes, airport transfers, and business trips. Ensures punctuality, safety, and comfort for employees."
    },
    {
      "name": "Shift-Wise Cab Service Pune",
      "description": "Corporate shift-wise cab service in Pune providing timely pickups and drop-offs for morning, evening, and night shifts. Features AC/non-AC vehicles, professional drivers, and flexible route management."
    },
    {
      "name": "Innova Corporate Cab Pune",
      "description": "Spacious Innova corporate cab in Pune offering AC comfort, professional drivers, luggage assistance, and smooth rides for group travel, employee transport, and long-distance business trips."
    },
    {
      "name": "Innova Crysta Corporate Cab Pune",
      "description": "Premium Innova Crysta corporate cab in Pune with luxury interiors, AC comfort, professional chauffeurs, luggage support, and safe travel for executives, VIP employees, and business trips."
    },
    {
      "name": "Ertiga Corporate Cab Pune",
      "description": "Comfortable Ertiga corporate cab in Pune for small teams or employee groups. Offers AC/non-AC options, luggage support, professional drivers, and safe highway travel."
    },
    {
      "name": "Sedan Corporate Cab Pune",
      "description": "Sedan corporate cab service in Pune offering smooth, comfortable rides with AC/non-AC options, professional drivers, luggage support, and punctual office pickups and drop-offs."
    },
    {
      "name": "Executive Car Rental Pune",
      "description": "Executive car rental service in Pune with luxury Sedans, SUVs, and premium vehicles for corporate travel, business meetings, airport transfers, and VIP client visits. Includes AC, luggage support, and experienced chauffeurs."
    },
    {
      "name": "Luxury Corporate Cab Pune",
      "description": "High-end luxury corporate cab service in Pune offering premium vehicles such as Innova Crysta, luxury SUVs, and executive Sedans. Ideal for VIP employees, business executives, and corporate events with AC comfort, luggage support, and professional drivers."
    },
    {
      "name": "Corporate Cab Service for Night Shift Pune",
      "description": "Safe and reliable night shift corporate cab service in Pune with AC/non-AC vehicles, professional drivers, real-time tracking, and secure routes for late-night office commutes."
    },
    {
      "name": "BPO Cab Service Pune",
      "description": "Corporate cab service in Pune designed for BPO employees with shift-wise pickups and drop-offs, AC/non-AC options, professional drivers, and safe, punctual transport."
    },
    {
      "name": "IT Company Cab Service Pune",
      "description": "Corporate cab service in Pune tailored for IT companies, offering daily office transport, shift-wise schedules, AC/non-AC vehicles, professional drivers, luggage assistance, and safe travel."
    },
    {
      "name": "24x7 Corporate Cab Service Pune",
      "description": "Round-the-clock corporate cab service in Pune providing AC/non-AC Sedans, SUVs, and Innova for employees, executives, and airport transfers with professional drivers and flexible schedules."
    },
    {
      "name": "Corporate Cab Service Hinjewadi",
      "description": "Reliable corporate cab service in Hinjewadi, Pune with AC/non-AC vehicles, professional drivers, luggage support, shift-wise pickups, and punctual office commutes for IT and corporate employees."
    },
    {
      "name": "Corporate Cab Service Wakad",
      "description": "Efficient corporate cab service in Wakad, Pune offering AC/non-AC Sedans, SUVs, and Innova for office and airport transfers, night shifts, and daily employee transportation with experienced drivers."
    },
    {
      "name": "Corporate Cab Service Baner",
      "description": "Top-rated corporate cab service in Baner, Pune providing AC/non-AC vehicles, professional drivers, shift-wise office pickups/drop-offs, and safe, comfortable travel for employees and executives."
    },
    {
      "name": "Corporate Cab Service Kharadi",
      "description": "Corporate cab service in Kharadi, Pune with multiple vehicle options, AC/non-AC comfort, professional drivers, luggage assistance, flexible office routes, and round-the-clock service."
    },
    {
      "name": "Corporate Cab Service Hadapsar",
      "description": "Office and corporate cab service in Hadapsar, Pune offering AC/non-AC Sedans, SUVs, Innova, and luxury cars for employee transport, airport transfers, and shift-wise pickups/drop-offs."
    },
    {
      "name": "Corporate Cab Service Pimpri Chinchwad",
      "description": "Reliable corporate cab service in Pimpri Chinchwad, Pune with AC/non-AC vehicles, professional drivers, luggage support, flexible schedules, and safe transport for employees and office staff."
    },
    {
      "name": "Corporate Cab Service Magarpatta",
      "description": "Corporate cab service in Magarpatta, Pune providing daily office transport, AC/non-AC vehicles, professional drivers, luggage assistance, shift-wise pickups, and safe commute for corporate employees."
    },
    {
      "name": "Corporate Cab Services in Pune Cost",
      "description": "Transparent pricing for corporate cab services in Pune based on vehicle type, AC/non-AC preference, distance, shift-wise schedules, and monthly or daily packages. Includes driver allowance and toll charges."
    },
    {
      "name": "Monthly Employee Transport Packages",
      "description": "Cost-effective monthly cab packages for employee transportation in Pune offering AC/non-AC vehicles, professional drivers, fixed routes, shift-wise pickups/drop-offs, and flexible schedules for offices and corporate clients."
    },
    {
      "name": "Night Shift Corporate Cab Safety",
      "description": "Specialized night shift corporate cab service in Pune ensuring employee safety with professional drivers, real-time tracking, well-lit pickup points, AC/non-AC comfort, and secure routes for late-night office travel."
    }
  ],
  "tableData": [
    ["Corporate Taxi Service Pune", "Corporate Cab Service Pune"],
    ["Corporate Travel Cab Pune", "Corporate Car Rental Pune"],
    ["Company Cab Service in Pune", "Office Cab Service Pune"],
    ["Corporate Cab Booking Pune", "Corporate Taxi Booking Pune"],
    ["Best Corporate Cab Services in Pune", "Reliable Corporate Cab Service Pune"],
    ["Affordable Corporate Cab Services Pune", "Corporate Cab Service Provider Pune"],
    ["Corporate Cab Vendor Pune", "Employee Transport Service Pune"],
    ["Office Pickup Drop Cab Pune", "Staff Transportation Service Pune"],
    ["Employee Cab Service Pune", "Daily Office Cab Service Pune"],
    ["Shift-Wise Cab Service Pune", "Innova Corporate Cab Pune"],
    ["Innova Crysta Corporate Cab Pune", "Ertiga Corporate Cab Pune"],
    ["Sedan Corporate Cab Pune", "Executive Car Rental Pune"],
    ["Luxury Corporate Cab Pune", "Corporate Cab Service for Night Shift Pune"],
    ["BPO Cab Service Pune", "IT Company Cab Service Pune"],
    ["24x7 Corporate Cab Service Pune", "Corporate Cab Service Hinjewadi"],
    ["Corporate Cab Service Wakad", "Corporate Cab Service Baner"],
    ["Corporate Cab Service Kharadi", "Corporate Cab Service Hadapsar"],
    ["Corporate Cab Service Pimpri Chinchwad", "Corporate Cab Service Magarpatta"],
    ["Corporate Cab Services in Pune Cost", "Monthly Employee Transport Packages"],
    ["Night Shift Corporate Cab Safety", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and professional corporate cab services in Pune — perfect for office commutes, client meetings, airport transfers, and employee transportation."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our corporate cab fares in Pune are affordable and transparent, with options for hourly rentals, monthly packages, and long-term corporate contracts."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars to meet your company’s transportation needs, team size, and comfort preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced in corporate travel, punctual, and trained to provide a safe and smooth commute within Pune."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups and drop-offs across Pune, including offices, airports, railway stations, hotels, and residential areas."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our corporate vehicles are regularly serviced, sanitized, and equipped with essential amenities to ensure a comfortable and hygienic ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, schedule changes, and travel planning for your corporate cab services."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your corporate cab in Pune easily through a call, WhatsApp, or our website — with instant confirmation and reliable service."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer corporate cab services in Pune?',
    answer: 'Yes, Sai Trupti Cabs provides professional and reliable corporate cab services for office commutes, airport transfers, and corporate events in Pune.',
  },
  {
    question: 'How can I book corporate cabs in Pune with Sai Trupti Cabs?',
    answer: 'You can book corporate cabs through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, and premium cars to suit your company’s needs and employee travel requirements.',
  },
  {
    question: 'Are the drivers experienced for corporate travel in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and trained to handle corporate travel with punctuality and safety.',
  },
  {
    question: 'Can I hire corporate cabs for monthly or long-term contracts?',
    answer: 'Yes, Sai Trupti Cabs offers flexible packages including hourly rentals, daily, and monthly corporate cab services.',
  },
  {
    question: 'Is corporate cab service in Pune available 24×7?',
    answer: 'Yes, our corporate cab service is available round the clock to ensure timely pickups and drop-offs.',
  },
  {
    question: 'What are the corporate cab fares in Pune?',
    answer: 'Our fares are transparent and start from approximately ₹500 for short trips, with customizable packages for long-term or regular corporate travel.',
  },
  {
    question: 'What payment options are accepted for corporate cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for corporate cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety protocols.',
  },
  {
    question: 'Is customer support available during corporate cab rides?',
    answer: 'Yes, our 24×7 customer support team is available throughout your corporate cab journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajiv Menon',
    feedback: 'Sai Trupti Cabs has been excellent for our company’s daily office commutes. Professional drivers and clean cars every time.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Reliable corporate cab service in Pune. Booking is easy, and drivers are punctual and courteous.',
    rating: 5,
  },
];



















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Services in Pune",
  "image": "https://saitrupticabs.com/assets/images/corporate-cab-pune.jpg",
  "description": "Sai Trupti Cabs provides corporate cab services in Pune for IT companies, employee transportation, airport transfers and office pickup drop. Book AC sedan, SUV and Innova Crysta cabs with professional drivers, GPS tracking and 24x7 support.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "12450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/corporate-cab-services-in-pune"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Corporate Cab Services in Pune | Employee Transport & IT Cab | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Corporate cab services in Pune for IT companies, employee transport, airport transfers and office pickup drop. Book Innova Crysta, sedan & SUV with Sai Trupti Cabs. Reliable corporate taxi service with 24x7 support." 
  />

  <meta 
    name="keywords" 
    content="corporate cab services pune, employee transportation pune, office cab service pune, IT company cab service pune, corporate taxi pune, airport corporate cab pune, pickup drop service pune, monthly corporate cab pune, business travel cab pune, corporate car rental pune, innova corporate cab pune, sedan corporate taxi pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinpune;